import api from '../utils/api';

export const getAllTopics = (config = {}) => {
    const {options} = config;
    return api({
        url: `api/content/get-all-hot-topics`,
        method: "GET",
        ...options,
    });
}
